import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IFileBasedExamAttemptSubmissionsDto,
  IFileBasedExamAttemptSubmissionsResponse,
} from "./types";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createGetAllApi } from "@/api/util/createGetAllApi";
import type { ICourseResponse } from "@/api/courses/types";
import type { IFileBasedExamResponse } from "@/api/courses/exams/fileBased/types";
import type { IFileBasedExamAttemptResponse } from "@api/courses/exams/fileBased/attempts/types";
import { createDeleteApi } from "@/api/util/createDeleteApi";
import { createPatchApi } from "@/api/util/createPatchApi";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<
      IFileBasedExamAttemptSubmissionsResponse,
      {
        course: ICourseResponse;
        exam: IFileBasedExamResponse;
        attempt: IFileBasedExamAttemptResponse;
      }
    >
  >,
  IPathBaseParam,
  IPaginationParams
>("courses.exams.fileBased.attempt.fileBasedExamAttemptSubmissions");

const postApis = createPostApi<
  IApiResponse<IFileBasedExamAttemptSubmissionsResponse>,
  IPathBaseParam,
  IFileBasedExamAttemptSubmissionsDto
>("courses.exams.fileBased.attempt.fileBasedExamAttemptSubmissions");

const getApis = createGetApi<
  IApiResponse<IFileBasedExamAttemptSubmissionsResponse>,
  IPathByIdParam,
  object
>("courses.exams.fileBased.attempt.fileBasedExamAttemptSubmissions");

const patchApis = createPatchApi<
  IApiResponse<IFileBasedExamResponse>,
  IPathByIdParam,
  IFileBasedExamAttemptSubmissionsDto
>("courses.exams.fileBased.attempt.fileBasedExamAttemptSubmissions");

const deleteApis = createDeleteApi<
  IApiResponse<IFileBasedExamAttemptSubmissionsResponse>,
  IPathByIdParam
>("courses.exams.fileBased.attempt.fileBasedExamAttemptSubmissions");

export const fileBasedExamAttemptSubmissions = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
};
